import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';

import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import { Icon, Menu, NavLink } from '@frontendmentorio/design-system-v2';

import GitHubAuthButton from 'features/shared/GitHubAuthButton';

const iconStyles = tv({
  base: ['text-neutral-900', 'transition-transform'],
  variants: {
    isActive: {
      true: ['rotate-180'],
    },
  },
});

const MenuButton = forwardRef(({ children, isActive, ...props }, ref) => {
  return (
    <button
      className={NavLink.styles({
        level: 'primary',
      })}
      ref={ref}
      {...props}
    >
      {children}
      <Icon
        className={iconStyles({ isActive })}
        name="chevron-down"
        style="solid"
      />
    </button>
  );
});

export default function NavLinks() {
  const currentUser = useSelector(selectCurrentUser);

  return (
    <nav aria-label="Primary">
      <ul className="flex gap-4 items-center">
        <li className="hidden desktop:block">
          <Menu
            button={forwardRef((props, ref) => (
              <MenuButton {...props} ref={ref}>
                Explore
              </MenuButton>
            ))}
          >
            <Menu.Nav>
              <Menu.Item>
                <NavLink
                  className="gap-3"
                  href="/learning-paths"
                  isUnderlineOnHover={false}
                >
                  <Icon className="text-lg" name="route" />
                  Learning paths
                </NavLink>
              </Menu.Item>

              <Menu.Item>
                <NavLink
                  className="gap-3"
                  href="/challenges"
                  isUnderlineOnHover={false}
                >
                  <Icon className="text-lg" name="laptop-mobile" />
                  Challenges
                </NavLink>
              </Menu.Item>

              <Menu.Item>
                <NavLink
                  className="gap-3"
                  href="/solutions"
                  isUnderlineOnHover={false}
                >
                  <Icon className="text-lg" name="code" />
                  Solutions
                </NavLink>
              </Menu.Item>

              <Menu.Item>
                <NavLink
                  className="gap-3"
                  href="/articles"
                  isUnderlineOnHover={false}
                >
                  <Icon className="text-lg" name="newspaper" />
                  Articles
                </NavLink>
              </Menu.Item>
            </Menu.Nav>
          </Menu>
        </li>

        <li className="hidden desktop:block">
          <Menu
            button={forwardRef((props, ref) => (
              <MenuButton {...props} ref={ref}>
                For companies
              </MenuButton>
            ))}
          >
            <Menu.Nav>
              <Menu.Item>
                <NavLink
                  className="gap-3"
                  href={process.env.HIRING_PLATFORM_URL}
                  isUnderlineOnHover={false}
                >
                  <Icon className="text-lg" name="user-tie" />
                  Hire developers
                </NavLink>
              </Menu.Item>

              <Menu.Item>
                <NavLink
                  className="gap-3"
                  href={process.env.TEAMS_PLATFORM_URL}
                  isUnderlineOnHover={false}
                >
                  <Icon className="text-lg" name="user-graduate" />
                  Train developers
                </NavLink>
              </Menu.Item>
            </Menu.Nav>
          </Menu>
        </li>

        {!currentUser?.hasActiveSubscription && (
          <li className="hidden desktop:block">
            <NavLink className="gap-1" href="/pro">
              Unlock{' '}
              <span className="bg-blue-500 px-1 rounded text-white tracking-wider">
                Pro
              </span>
            </NavLink>
          </li>
        )}

        {!currentUser && (
          <li>
            <GitHubAuthButton className="py-2 text-sm" />
          </li>
        )}
      </ul>
    </nav>
  );
}
